// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1b1rM","name":"styles_name__mTQIG","phone":"styles_phone__1ZVqn"};